module.exports = __webpack_public_path__ + "static/media/upload-icon-large.2b768398.svg";